import React, { createContext, useContext, useEffect, useState } from 'react';
import { getDatabase, ref, onValue, set, remove } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { migrateUserNotifications } from '../services/notificationMigrationService';

const NotificationsContext = createContext();

export const useNotifications = () => {
  return useContext(NotificationsContext);
};

export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const auth = getAuth();

  useEffect(() => {
    const db = getDatabase();
    let unsubscribeNotifications = () => {};

    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      // Drop the previous user's listener before starting the next one.
      unsubscribeNotifications();
      unsubscribeNotifications = () => {};
      setNotifications([]);
      if (!user) return;

      // Anything still at the old users/{uid}/notifications path moves over.
      migrateUserNotifications(user.uid).catch((err) =>
        console.error('Could not move notifications to the new path', err)
      );

      unsubscribeNotifications = onValue(ref(db, `notifications/${user.uid}`), (snapshot) => {
        const data = snapshot.val();
        setNotifications(data ? Object.keys(data).map((key) => ({ id: key, ...data[key] })) : []);
      });
    });

    return () => {
      unsubscribeAuth();
      unsubscribeNotifications();
    };
  }, []);
  
  
  const markAsRead = (id) => {
    const user = auth.currentUser;
    if (!user) return;
    const db = getDatabase();
    const notificationRef = ref(db, `notifications/${user.uid}/${id}/read`);
    set(notificationRef, true);
  };

  const markAsUnread = (id) => {
    const user = auth.currentUser;
    if (!user) return;
    const db = getDatabase();
    const notificationRef = ref(db, `notifications/${user.uid}/${id}/read`);
    set(notificationRef, false);
  };

  const deleteNotification = (id) => {
    const user = auth.currentUser;
    if (!user) return;
    const db = getDatabase();
    const notificationRef = ref(db, `notifications/${user.uid}/${id}`);
    remove(notificationRef);
  };

  return (
    <NotificationsContext.Provider value={{ notifications, markAsRead, markAsUnread, deleteNotification }}>
      {children}
    </NotificationsContext.Provider>
  );
};